import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { Observable, of, skipWhile } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  public constructor(private readonly globalService: GlobalService, private readonly router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (this.globalService.globalInfo.isLoaded) {
      return of(this.checkAccess(route));
    } else {
      return this.globalService
        .select((state) => state.isLoaded)
        .pipe(
          skipWhile((isLoaded) => isLoaded === false),
          map(() => this.checkAccess(route))
        );
    }
  }

  private checkAccess(route: ActivatedRouteSnapshot): boolean {
    const modules = this.globalService.globalInfo.tenantInfo?.ratePlan?.availableModules;

    if (!route.data?.accessName) {
      return true;
    }

    if (
      Array.isArray(route.data.accessName) &&
      modules?.some((module) => module && route.data.accessName.includes(module))
    ) {
      return true;
    }

    if (
      !Array.isArray(route.data.accessName) &&
      modules?.find((module) => module === route.data.accessName)
    ) {
      return true;
    }

    this.router.navigate(['/']).catch(console.error);
    return false;
  }
}
